import { useNavigate } from "react-router-dom";
import { Clock, Crown, XCircle } from "lucide-react";
import { useAuth } from "../lib/auth";

/**
 * Banner che compare nell'AppShell quando l'utente è in trial con ≤5gg rimasti
 * o quando l'abbonamento è scaduto.
 */
export function TrialBanner() {
    const { user } = useAuth();
    const navigate = useNavigate();
    if (!user) return null;
    const status = user.subscription_status;
    const days = user.days_left ?? 0;

    if (status === "active") return null;

    const isExpired = status === "expired";
    const lowTrial = status === "trialing" && days <= 5;
    if (!isExpired && !lowTrial) return null;

    const tint = isExpired ? "#d32f2f" : "#c9a961";
    const bg = isExpired ? "rgba(211,47,47,0.08)" : "rgba(201,169,97,0.12)";
    const title = isExpired
        ? "Il tuo periodo di prova è terminato"
        : days <= 0
            ? "Ultimo giorno di prova"
            : `Ti restano ${days} giorn${days === 1 ? "o" : "i"} di prova`;
    const sub = isExpired
        ? "Abbonati a 29€/mese per continuare a usare RENOVA360."
        : "Abbonati ora per evitare interruzioni. Solo 29€ al mese.";

    return (
        <div
            className="rounded-xl px-4 sm:px-5 py-3.5 mb-6 flex items-center gap-3 border flex-wrap"
            style={{ background: bg, borderColor: `${tint}55` }}
            data-testid="trial-banner"
        >
            <div
                className="h-9 w-9 rounded-full flex items-center justify-center shrink-0"
                style={{ background: `${tint}22`, color: tint }}
            >
                {isExpired ? <XCircle size={18} /> : <Clock size={18} />}
            </div>
            <div className="flex-1 min-w-[220px]">
                <div className="font-display text-base sm:text-lg text-brand-ink leading-tight">{title}</div>
                <div className="text-[12px] text-brand-muted mt-0.5">{sub}</div>
            </div>
            <button
                onClick={() => navigate("/billing")}
                data-testid="trial-banner-upgrade"
                className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-xs font-bold text-brand-navy hover:bg-brand-goldDark transition-colors"
                style={{ background: "#c9a961" }}
            >
                <Crown size={14} /> Abbonati ora
            </button>
        </div>
    );
}
